export default {
    inject: {
        model: {}
    }
}